/** Google map key */
export const GOOGLE_MAP_KEY = "AIzaSyACVcW7qBPdSi47lId2QL2HQwQzfusHwo0";